export default __webpack_public_path__ + "static/media/unmute.b71d30cf.svg";